import axios from "axios";
import  config  from "../../config";
const apiurl = config.ADMIN_BASE_URL;
const attributesApiUrl = config.GET_ATTRIBUTES_BASE_URL;

const getToken = () => {
    return localStorage.getItem("cookies");
};

export const fetchProjects = async (page) => {
    console.log("Fetching projects for page:", page);
    const token = getToken();
    try {
        const response = await axios.get(`${apiurl}/projects?page=${page}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    }
    catch (error) {
        console.error("Error fetching projects:", error);
        throw error;
    }
}

export const fetchUserProjects = async (userId, page) => {
    const token = getToken();
    try {
        const response = await axios.get(`${apiurl}/projects?user_id=${userId}&page=${page}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    }
    catch (error) {
        console.error("Error fetching projects:", error);
        throw error;
    }
}



export const getProjectById = async (projectId) => {
    const token = getToken();
    try {
        const response = await axios.get(`${apiurl}/projects/${projectId}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    }
    catch (error) {
        console.error("Error fetching project by ID:", error);
        throw error;
    }
}


export const filterList = async () => {
    const token = getToken();
    try {
        const response = await axios.get(`${apiurl}/projects/filter-list`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    }
    catch (error) {
        console.error("Error filtering projects:", error);
        throw error;
    }
}


export const filterProjects = async (query) => {
    console.log("filterProjects testing :", query);
    const token = getToken();
    try {
        const response = await axios.get(
            `${apiurl}/projects?${query}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error filtering projects:", error);
        throw error;
    }
}

export const filterUserProjects = async (userId, filters) => {

    console.log("User ID for filtering projects:", userId);
    console.log("Query for filtering user projects:", filters);
    const token = getToken();
    try {
        const response = await axios.get(
            `${apiurl}/projects?user_id=${userId}&${filters}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error filtering user projects:", error);
        throw error;
    }
}


export const actionOnProject = async (projectId, status) => {
    console.log("Project ID:", projectId, "Status:", status);
    const token = getToken();
    try {
        const response = await axios.put(
            `${apiurl}/projects/${projectId}/status`,
            { status },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error performing action on project:", error);
        throw error;
    }
}






export const fetchWorks = async (page = 1) => {
    const token = getToken();
    try {
        const response = await axios.get(`${apiurl}/work-listing?page=${page}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    }
    catch (error) {
        console.error("Error fetching works:", error);
        throw error;
    }
}


export const fetchUserWorks = async (userId, page) => {
    const token = getToken();
    try {
        const response = await axios.get(`${apiurl}/work-listing?user_id=${userId}&page=${page}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    }
    catch (error) {
        console.error("Error fetching works:", error);
        throw error;
    }
}




export const workFilter = async () => {
    const token = getToken();
    try {
        const response = await axios.get(`${apiurl}/work-listing/filter-list`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    }
    catch (error) {
        console.error("Error filtering projects:", error);
        throw error;
    }
}



export const filterWorks = async (query) => {
    const token = getToken();
    try {
        const response = await axios.get(
            `${apiurl}/work-listing?${query}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error filtering :", error);
        throw error;
    }
}

export const filterUserWorks = async (userId, filters) => {
    const token = getToken();
    try {
        const response = await axios.get(
            `${apiurl}/work-listing?user_id=${userId}&${filters}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error filtering user works:", error);
        throw error;
    }
}


export const getWorkById = async (workId) => {
    const token = getToken();
    try {
        const response = await axios.get(`${apiurl}/work-listing/${workId}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    }
    catch (error) {
        console.error("Error fetching work by ID:", error);
        throw error;
    }
}


export const actionOnWork = async (workId, status) => {
    console.log("Work ID:", workId, "Status:", status);
    const token = getToken();
    try {
        const response = await axios.put(
            `${apiurl}/work-listing/${workId}/status`,
            { status },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error performing action on work:", error);
        throw error;
    }
}

// project type (/v1/project-types)
export const getProjectTypes = async () => {
  try {
    const response = await axios.get(`${attributesApiUrl}/api/v1/project-types`);
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

// get project locations
export const getProjectLocations = async (search) => {
  try {
    const response = await axios.get(
      `${attributesApiUrl}/api/v1/work-locations?city=${search}`
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

// /api/v1/work-languages
export const getProjectLanguages = async () => {
  try {
    const response = await axios.get(`${attributesApiUrl}/api/v1/work-languages`);
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

///api/v1/genre-list
export const getProjectGenres = async () => {
  try {
    const response = await axios.get(`${attributesApiUrl}/api/v1/projects/genre-list`);
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};